import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  practitioners: [],
  loading: false,
  error: null,
};

const practitionersRequest = createAction("practitionersRequest");
const practitionersSuccess = createAction("practitionersSuccess");
const practitionersFailure = createAction("practitionersFailure");

export const practitionersReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(practitionersRequest, (state, action) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(practitionersSuccess, (state, action) => {
      state.loading = false;
      state.practitioners = action.payload; // ✅ Changed from .practitioners to .staff
      state.error = null;
    })
    .addCase(practitionersFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.practitioners = [];
    });
});
